import React, { Fragment, useEffect, useState } from "react";
import { Card, CardBody, Media } from "reactstrap";
import { H6, LI, P, UL, Image } from "../../../AbstractElements";
// import user from '../../../assets/images/user/user.png';
import { Inbox, MarekjecnoMailId, MARKJENCO, NEWMAIL } from "../../../Constant";
// import { emailSidbar } from "../../../Data/Email";
import { Link } from "react-router-dom";
import useAxios from "../../../Utils/useAxios";

const MailSidebar = ({
  moduleOpen,
  IsOpen,
  OnHandelClick,
  moduleList,
  mailList,
}) => {
  return (
    <Fragment>
      <div className="md-sidebar">
        {/* <a
          className="btn btn-primary md-sidebar-toggle"
          href="#javascript"
          onClick={OnHandelClick}
        >
          email filter
        </a> */}
        <div className={`md-sidebar-aside ${IsOpen ? "open" : ""}`}>
          <div className="email-left-aside">
            <Card>
              <CardBody>
                <div className="email-app-sidebar">
                  <UL
                    attrUL={{
                      className: "simple-list nav main-menu custom-scrollbar",
                      role: "tablist",
                    }}
                  >
                    {(mailList || moduleList)?.map((item) => {
                      return (
                        <LI key={item.id}>
                          <a
                            className={
                              item.module === moduleOpen
                                ? "bg-primary text-white"
                                : ""
                            }
                            onClick={() => OnHandelClick(item.module)}
                          >
                            <span
                              className={`${
                                item.module === moduleOpen ? "text-white" : ""
                              } title`}
                            >
                              {item.module}
                            </span>
                            <span
                              className={`${
                                item.module === moduleOpen ? "text-white" : ""
                              } badge pull-right`}
                            >
                              {item.count}
                              {/* {getUnreadCountByModule(item.module)} */}
                            </span>
                          </a>
                        </LI>
                      );
                    })}
                  </UL>
                </div>
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
export default MailSidebar;
